import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "stage-generator"
};
const _hoisted_2 = {
  class: "left-side"
};
const _hoisted_3 = {
  class: "info-container"
};
const _hoisted_4 = {
  key: 0,
  class: "drama-name"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
import { ElButton, ElCol, ElDatePicker, ElForm, ElInput, ElInputNumber, ElMessage, ElOption, ElRow, ElSelect } from 'element-plus';
import { computed, onMounted, ref, watch } from 'vue';
import store from '@/store';
import { request } from '@/manager/net_manager';
import { calculateMD5, compressImage, getPerformanceDesc, inApostleType, isAdminType, placeholderImage } from '@/tools/utils';
import dayjs from 'dayjs'; // constants

export default {
  __name: 'StageGenerator',
  props: {
    dramaId: {
      type: [String, Number, null],
      required: false,
      default: () => null
    },
    stageId: {
      type: [String, Number, null],
      required: false,
      default: () => null
    }
  },
  emits: ['closeGenerator', 'deleteStage'],

  setup(__props, {
    emit: __emit
  }) {
    const statusArray = Array.from({
      length: 3
    }, (_, index) => {
      return {
        'id': index,
        'name': getPerformanceDesc(index)
      };
    }); // pre-declaration

    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const imageInput = ref(null);
    const preview = ref(null);
    const drama = ref(null);
    const stage = ref(null);
    const stageForm = ref({
      drama_id: null,
      name: '',
      date: [],
      actor_capacity: 2,
      audience_capacity: 0,
      public: true,
      stage_image_id: null,
      apostle_id: null,
      joinable: true,
      status: 0
    });
    const reminderFlag = ref(false);
    const reminderTitle = ref('');
    const reminderContent = ref('');
    const reminderEvent = ref(null); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const worldOutlook = computed(() => {
      return store.state.world_outlook ? store.state.world_outlook : null;
    });
    const apostles = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.apostles ?? null;
    });
    const ferrymen = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.ferrymen ?? null;
    }); // functions

    const getData = () => {
      if (worldOutlook.value) {
        if (isAdminType(userType.value) && !apostles.value) {
          request('world_outlook/get_wo_apostles/', {
            'world_outlook_id': worldOutlook.value.id
          }, 'POST').then(response => {
            // console.log(JSON.stringify(response))
            if (response.code === 0) {
              store.commit('update_wo_info', {
                wo_id: worldOutlook.value.id,
                key: 'apostles',
                value: response.data
              });
            }
          });
        }

        if (inApostleType(userType.value) && !ferrymen.value) {
          request('ferryman/list/', {
            'world_outlook_id': worldOutlook.value.id,
            'is_precis': true
          }, 'POST').then(response => {
            // console.log(JSON.stringify(response))
            if (response.code === 0) {
              store.commit('update_wo_info', {
                wo_id: worldOutlook.value.id,
                key: 'ferrymen',
                value: response.data.data_array
              });
            }
          });
        }
      }
    };

    const getDramaData = () => {
      if (props.dramaId) {
        stageForm.value['drama_id'] = parseInt(props.dramaId);
        let parameters = {
          'drama_id': props.dramaId,
          'is_precis': true
        };
        request('drama/get/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code !== 0) {
            ElMessage.error({
              message: response.msg,
              duration: 1500
            });
            return;
          }

          drama.value = response.data;
        });
      }
    };

    const getStageData = () => {
      if (props.stageId) {
        request('stage/get/', {
          'stage_id': props.stageId
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code !== 0) {
            ElMessage.error({
              message: response.msg,
              duration: 1500
            });
            return;
          }

          stage.value = response.data;
          loadStageData();
        });
      }
    };

    const loadStageData = () => {
      stageForm.value = {
        drama_id: parseInt(stage.value?.performance?.drama?.drama_id),
        ferryman_id: parseInt(stage.value.ferryman.id),
        stage_image_id: parseInt(stage.value.stage_image_id),
        name: stage.value.stage_name,
        date: [stage.value.performance.start_date, stage.value.performance.end_date],
        actor_capacity: stage.value.actor_capacity,
        audience_capacity: stage.value.audience_capacity,
        public: stage.value.public,
        joinable: stage.value.joinable,
        status: stage.value.performance.status
      };
      preview.value = stage.value?.stage_image ?? stage.value?.performance?.drama?.image_url;

      if (isAdminType(userType.value)) {
        stageForm.value.apostle_id = stage.value.performance.anchor.id;
      }

      drama.value = stage.value?.performance?.drama ?? null;
    };

    const useDramaImage = () => {
      if (drama.value) {
        preview.value = drama.value?.image_url ?? null;
      } else {
        preview.value = null;
      }

      stageForm.value.stage_image_id = null;
    };

    const uploadCustomImage = () => {
      imageInput.value?.click();
    };

    const statusChanged = value => {
      // console.log(value)
      if (value === 2) {
        stageForm.value.joinable = false;
      }
    };

    const handleInputChange = event => {
      let file = event.target.files[0];

      if (file) {
        compressImage(file, 1024 * 1024, compressedFile => {
          calculateMD5(compressedFile, async md5 => {
            const formData = new FormData();
            formData.append('file', file);
            formData.set('name', file.name);
            formData.set('path', 'stage_image');
            formData.set('md5', md5);
            const headers = {
              'Content-Type': 'multipart/form-data'
            };
            const response = await request('basic/upload_file/', formData, 'UPLOAD', headers); // console.log(`upload stage_image ${JSON.stringify(response)}`)

            if (response.code !== 0) {
              ElMessage.error({
                message: response.msg,
                duration: 1500
              });
            } else {
              preview.value = URL.createObjectURL(file);
              stageForm.value.stage_image_id = response.data['file_id'].toString();
            }

            file = null;
            imageInput.value.value = null;
          });
        });
      }
    };

    const handleDateChange = value => {
      let buffer = [];

      for (let i = 0; i < value.length; i++) {
        buffer.push(dayjs(value[i]).tz('Asia/Shanghai').format('YYYY-MM-DD'));
      }

      stageForm.value.date = buffer;
    };

    const closeStage = () => {
      if (!stage.value) return;
      reminderFlag.value = true;
      reminderTitle.value = `删除前确认`;
      reminderContent.value = `确认关闭舞台 “${stage.value.stage_name}” 吗？`;

      reminderEvent.value = confirm => {
        reminderEvent.value = null;
        reminderFlag.value = false;
        reminderTitle.value = '';
        reminderContent.value = '';

        if (confirm) {
          request('stage/close/', {
            'stage_id': stage.value.stage_id
          }, 'POST').then(response => {
            // console.log(JSON.stringify(response))
            if (response.code !== 0) {
              ElMessage.error({
                message: response.msg,
                duration: 1500
              });
              return;
            }

            emits('closeGenerator');
          });
        }
      };
    };

    const onSubmit = () => {
      if (message.value) {
        message.value.close();
      }

      if (!stageForm.value.name) {
        message.value = ElMessage.error({
          message: '需要一个舞台名称',
          duration: 1500
        });
        return;
      }

      if (stageForm.value.date.length === 0) {
        message.value = ElMessage.error({
          message: '需要指定演出日期',
          duration: 1500
        });
        return;
      }

      if (!stageForm.value.drama_id) {
        message.value = ElMessage.error({
          message: '需要指定剧本',
          duration: 1500
        });
        return;
      }

      if (!stageForm.value.apostle_id && userType.value !== 2) {
        message.value = ElMessage.error({
          message: '需要指定链接者',
          duration: 1500
        });
        return;
      }

      if (!stage.value) {
        request('stage/create/', stageForm.value, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            stageForm.value = {
              drama_id: null,
              name: '',
              date: [],
              actor_capacity: 2,
              audience_capacity: 0,
              public: true,
              stage_image_id: null,
              apostle_id: null
            };
            message.value = ElMessage.success({
              message: '舞台创建成功',
              duration: 1500
            });
            emits('closeGenerator');
          } else {
            message.value = ElMessage.error({
              message: response.msg,
              duration: 1500
            });
          }
        });
      } else {
        let parameters = {
          'updates': {
            'stage_id': stage.value.stage_id,
            ...stageForm.value
          }
        };
        request('stage/update/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            stageForm.value = {
              drama_id: null,
              name: '',
              date: [],
              actor_capacity: 2,
              audience_capacity: 0,
              public: true,
              stage_image_id: null,
              apostle_id: null
            };
            message.value = ElMessage.success({
              message: '舞台修改成功',
              duration: 1500
            });
            emits('closeGenerator');
          } else {
            message.value = ElMessage.error({
              message: response.msg,
              duration: 1500
            });
          }
        });
      }
    }; // lifecycle


    onMounted(() => getData()); // watcher

    watch(() => [props.dramaId, props.stageId], () => {
      if (props.stageId) {
        getStageData();
      } else if (props.dramaId) {
        getDramaData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("input", {
        type: "file",
        accept: "image/png, image/jpeg",
        style: {
          "display": "none"
        },
        ref_key: "imageInput",
        ref: imageInput,
        onChange: handleInputChange
      }, null, 544), _createVNode(_unref(ElForm), {
        model: stageForm.value,
        "label-width": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), null, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            style: {
              "align-items": "flex-start"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
              src: preview.value ?? _unref(placeholderImage),
              "zoom-rate": 1.2,
              "max-scale": 7,
              "min-scale": 0.2,
              "initial-index": 4,
              "show-progress": "",
              draggable: false,
              fit: "cover"
            }, null, 8, ["src"]), _createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_createVNode(_unref(ElButton), {
                onClick: useDramaImage
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" 使用剧本封面 ", -1)]))]),
                _: 1
              }), _createVNode(_unref(ElButton), {
                onClick: uploadCustomImage
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" 自定舞台幕布 ", -1)]))]),
                _: 1
              })]),
              _: 1
            })]), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElRow), {
              class: "form-row",
              style: {
                "justify-content": "space-between"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "舞台名称",
                "label-position": "left"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElInput), {
                  modelValue: stageForm.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => stageForm.value.name = $event),
                  maxlength: "32",
                  placeholder: "舞台名称",
                  type: "text",
                  clearable: "",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "使用剧本",
                "label-position": "left"
              }, {
                default: _withCtx(() => [drama.value ? (_openBlock(), _createElementBlock("text", _hoisted_4, _toDisplayString(drama.value?.name ?? ''), 1)) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_unref(ElRow), {
              class: "form-row",
              style: {
                "justify-content": "space-between"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "演出时间",
                "label-position": "left"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElDatePicker), {
                  modelValue: stageForm.value.date,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => stageForm.value.date = $event),
                  type: "daterange",
                  "range-separator": "To",
                  format: "YYYY/MM/DD",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  onChange: handleDateChange
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "指定舟子",
                "label-position": "left"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                  modelValue: stageForm.value.ferryman_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => stageForm.value.ferryman_id = $event),
                  placeholder: "选择舟子",
                  "no-data-text": "无数据",
                  "popper-class": "commonPopper"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ferrymen.value, (item, index) => {
                    return _openBlock(), _createBlock(_unref(ElOption), {
                      key: index,
                      label: item['nickname'],
                      value: item['id']
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_unref(ElRow), {
              class: "form-row"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "演员容量",
                "label-position": "left"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
                  modelValue: stageForm.value.actor_capacity,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => stageForm.value.actor_capacity = $event),
                  min: 1,
                  max: 8,
                  precision: 0,
                  placeholder: "演员容量"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_unref(ElRow), {
              class: "form-row"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "观众容量",
                "label-position": "left"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
                  modelValue: stageForm.value.audience_capacity,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => stageForm.value.audience_capacity = $event),
                  min: 0,
                  max: 8,
                  precision: 0,
                  placeholder: "观众容量"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _unref(isAdminType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
              key: 0,
              class: "form-row"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "指定链接",
                "label-position": "left"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                  modelValue: stageForm.value.apostle_id,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => stageForm.value.apostle_id = $event),
                  placeholder: "选择链接者",
                  "no-data-text": "无数据",
                  clearable: "",
                  "popper-class": "commonPopper"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apostles.value, (item, index) => {
                    return _openBlock(), _createBlock(_unref(ElOption), {
                      key: index,
                      label: item['name'],
                      value: item['id']
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), stage.value && _unref(inApostleType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
              key: 1,
              class: "form-row"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElCol), {
                span: 6
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "演出状态",
                  "label-position": "left"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                    modelValue: stageForm.value.status,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => stageForm.value.status = $event),
                    placeholder: "选择演出状态",
                    "no-data-text": "无数据",
                    "popper-class": "commonPopper",
                    onChange: statusChanged
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusArray), (item, index) => {
                      return _openBlock(), _createBlock(_unref(ElOption), {
                        key: index,
                        label: item['name'],
                        value: item['id']
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true)])]),
            _: 1
          }), stage.value ? (_openBlock(), _createBlock(_unref(ElRow), {
            key: 0,
            style: {
              "justify-content": "flex-end",
              "align-items": "center",
              "margin-top": "32px",
              "gap": "16px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElButton), {
              class: "close-stage",
              onClick: closeStage
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" 关闭舞台 ", -1)]))]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_unref(ElRow), {
            style: {
              "justify-content": "flex-end",
              "align-items": "center",
              "margin-top": "16px",
              "gap": "16px"
            }
          }, {
            default: _withCtx(() => [stage.value ? (_openBlock(), _createBlock(_component_el_switch, {
              key: 0,
              modelValue: stageForm.value.joinable,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => stageForm.value.joinable = $event),
              "active-text": "招募中",
              "inactive-text": "停止招募",
              "inline-prompt": ""
            }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_switch, {
              modelValue: stageForm.value.public,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => stageForm.value.public = $event),
              "active-text": "公开招募",
              "inactive-text": "私下筹备",
              "inline-prompt": ""
            }, null, 8, ["modelValue"]), _createVNode(_unref(ElButton), {
              onClick: onSubmit
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(stage.value ? '提交调整' : '创建舞台'), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_dialog, {
        modelValue: reminderFlag.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => reminderFlag.value = $event),
        title: reminderTitle.value,
        width: "800"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(ElButton), {
          onClick: _cache[9] || (_cache[9] = $event => reminderEvent.value(true))
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("确认", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElButton), {
          class: "cancel",
          onClick: _cache[10] || (_cache[10] = $event => reminderEvent.value(false))
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("取消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(reminderContent.value), 1)]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }

};